import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import CommonModal from "./CommonModal";
import Style from "./modal.module.scss";
import { demoAccount, reset_password } from "../../locales/en";
import "../../assets/scss/common.scss";
import { SIGN_UP } from "../../route/paths";

const DemoAccSetupModal = ({ isOpen, toggle }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title=""
      modalClassName={`${Style.xeroModal} modal-dialog-centered modal-lg`}
      bodyClassName={`${Style.manualUploadContent} modal-content border-0`}
      footerButtons={[
        {
          label: demoAccount?.btnText,
          className: "btn btn-primary",
          onClick: toggle
        }
      ]}
      hideFooter
    >
      <div className="inv-upload-template">
        <div className={Style.manul_Invoice_Submit}>
          <p>{demoAccount?.p3}</p>
          <p>{demoAccount?.p4}</p>
          <p>{demoAccount?.p5}</p>

          <p className={`text-center ${Style.demo_Acc_Form_Submit}`}>
            <Link to={SIGN_UP} className="btn btn-primary">
              {demoAccount?.linkText}
            </Link>
          </p>

          <p className="text-center font-16">{reset_password?.or}</p>

          <p className="text-center">
            <Link
              to="https://fundtap.pipedrive.com/scheduler/WrQwJPtE/fundtap-business-finance"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              {demoAccount?.linkText1}
            </Link>
          </p>

          <p className="text-center">
            <button onClick={toggle} className="btn btn-primary">
              {demoAccount?.btnText}
            </button>
          </p>
        </div>
      </div>
    </CommonModal>
  );
};

DemoAccSetupModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default DemoAccSetupModal;
